import { render, staticRenderFns } from "./ProfileAffiliateTable.vue?vue&type=template&id=0fdb8d55&scoped=true&"
import script from "./ProfileAffiliateTable.vue?vue&type=script&lang=ts&"
export * from "./ProfileAffiliateTable.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileAffiliateTable.vue?vue&type=style&index=0&id=0fdb8d55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdb8d55",
  null
  
)

export default component.exports